// extracted by mini-css-extract-plugin
export default {"serversTableContainer":"JoinServer_serversTableContainer__K0l03","refresh":"JoinServer_refresh__LiizI"};